import { render, staticRenderFns } from "./ButtonFull.vue?vue&type=template&id=2c228aa1&scoped=true&"
import script from "./ButtonFull.vue?vue&type=script&lang=js&"
export * from "./ButtonFull.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFull.vue?vue&type=style&index=0&id=2c228aa1&lang=scss&scoped=true&"
import style1 from "./ButtonFull.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c228aa1",
  null
  
)

export default component.exports